import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MdDialog, MdDialogRef } from '@angular/material';
import { ViewCvComponent} from '../view-cv/view-cv.component';

@Component({
  selector: 'app-item-candidates',
  templateUrl: './item-candidates.component.html',
  styleUrls: ['./item-candidates.component.css']
})
export class ItemCandidatesComponent implements OnInit {
  selectedOption;
  jobs: any;

  constructor(public dialog: MdDialog) { }

  ngOnInit() {
  }

  openCV(userId, jobId, jobName){
    let dialogRef = this.dialog.open(ViewCvComponent, {
      data: {userId:userId, jobId: jobId, name: jobName
      }});

    dialogRef.afterClosed().subscribe(result => {
      this.selectedOption = result;
    });
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/item-candidates/item-candidates.component.ts